import { HotelModel } from 'api-hooks/hotel';
import { Translate } from 'next-translate';
import * as Yup from 'yup';

export const HotelRoomFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    type: Yup.string().default(''),
    size: Yup.string().default(''),
    description: Yup.string().default(''),

    //additional information
    customId: Yup.string().default(''),
  });

export const HotelFormSchema = (t: Translate) =>
  Yup.object({
    area: Yup.string().default(''),
    description: Yup.string().default(''),
    email: Yup.string().email().default(''),
    phone: Yup.string().default(''),
    cityCountry: Yup.string().default(''),
    address: Yup.string().default(''),
    name: Yup.string().default(''),
    checkIn: Yup.string().default(''),
    checkOut: Yup.string().default(''),
    yearFounded: Yup.string()
      .matches(/^\d+$/, t('error:must_be_only_digits'))
      .default(''),
    preferences: Yup.array(Yup.string().default('')).default([]),
    hotelRooms: Yup.array(HotelRoomFormSchema()).default([]),
    regulation: Yup.string().default(''),
    mandatoryFee: Yup.string().default(''),
  });

export type HotelFormType = Yup.InferType<
  ReturnType<typeof HotelFormSchema>
> & {
  data?: HotelModel;
};

export type HotelRoomFormType = Yup.InferType<
  ReturnType<typeof HotelRoomFormSchema>
>;
